<template>
  <!-- TODO Slet hvis ikke skal bruges -->
  <div>
    <Loading v-if="!rules || !latestLists" />
    <div v-else>
      <vs-prompt
        @cancel="createNewListPromptActive = false"
        @close="createNewListPromptActive = false"
        @accept="createList"
        title="Create new list type"
        accept-text="Create list type"
        :active.sync="createNewListPromptActive"
      >
        <div>
          <div></div>
          <vs-input class="w-full" placeholder="Marketing Review" label="List display title" v-model="newListTitle" />
          <vs-input
            class="mt-2 w-full"
            placeholder="MarketingReview"
            label="List type - cannot be changed after creation"
            @keydown.space.prevent
            v-model="newListType"
          />
          <vs-input class="mt-2 w-full" label="Country" :value="$store.getters['venues/activeCountry'].name" :disabled="true" />
        </div>
      </vs-prompt>

      <div class="flex justify-between">
        <p>
          There are {{ rules.length }} notification rules.
          <span v-if="hasPermission('vp.life.lists.managerules')"
            >Click <vs-button size="small" @click.stop="manageRules" class="px-2 py-1">here</vs-button> to manage</span
          >
        </p>
        <vs-button icon="add" @click="createNewListPromptActive = true" type="relief" color="primary" class="mr-3">Create new</vs-button>
      </div>
      <div class="mt-5" v-for="categoryGroup in latestLists" :key="categoryGroup.category">
        <h3>{{ categoryGroup.category }}</h3>
        <vs-row>
          <vs-col class="p-3" vs-w="3" v-for="list in categoryGroup.lists" :key="list.id">
            <vs-card class="cursor-pointer" @click.native="listClicked(list.id)">
              <div slot="media">
                <img v-if="list.listTypeCategory == 'Other' && list.imageUrl" class="rounded-t-lg" :src="list.imageUrl" :alt="list.title" />
                <div
                  v-else-if="list.listTypeCategory == 'Other' && !list.imageUrl"
                  class="flex justify-center items-center rounded-t-lg w-full h-32 bg-white"
                >
                  <feather-icon icon="ArchiveIcon" class="w-8 h-8 text-grey" />
                </div>
                <img
                  v-else
                  class="rounded-t-lg"
                  :src="require(`@/assets/images/lists/${listTypeToImgName(list.type)}`)"
                  :alt="list.title"
                />
              </div>
              <h6>{{ list.title }}</h6>
              <div class="text-sm whitespace-pre-wrap">{{ list.description }}</div>
            </vs-card>
          </vs-col>
        </vs-row>
        <vs-divider />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FeatherIcon from "../../../../components/FeatherIcon.vue";

export default {
  components: { FeatherIcon },
  data() {
    return {
      createNewListPromptActive: false,
      newListTitle: "",
      newListType: ""
    };
  },
  computed: {
    ...mapGetters({
      latestLists: "lists/latestLists",
      rules: "listRules/rules"
    })
  },
  methods: {
    listTypeToImgName(listType) {
      // Handle types that start with a base type (e.g., FireProtectionMeasures2, FireProtectionMeasures3)
      if (listType.startsWith("FireProtectionMeasures")) {
        return "fire.png";
      }
      
      switch (listType) {
        case "VenueVisitLight":
          return "venue visits light.png";
        case "BarsWithRestaurantsThorough":
          return "food thorough.png";
        case "BarsAndNightclubsThorough":
          return "nightclub and bars thorough.png";
        case "CompetitorVisit":
          return "competitor.png";
        case "MaintenanceReviewLight":
          return "maintenance.png";
        case "MaintenanceReviewThorough":
          return "maintenance thorough.png";
        default:
          return "venue visits light.png";
      }
    },
    manageRules() {
      this.$router
        .push({
          name: "manage-list-rules"
        })
        .catch(() => {});
    },
    listClicked(listId) {
      this.$router
        .push({
          name: "manage-list",
          params: { id: listId }
        })
        .catch(() => {});
    },
    createList() {
      try {
        this.$store.dispatch("lists/createList", {
          title: this.newListTitle,
          listType: this.newListType,
          country: this.$store.getters["venues/activeCountry"].id
        });
        this.$vs.notify({
          color: "success",
          title: "List created",
          text: "List created successfully"
        });
        // refetch
        this.$store.dispatch("lists/getLatestLists", this.$store.getters["venues/activeCountry"].id);
      } catch (err) {
        console.log(err);
        this.$vs.notify({
          color: "danger",
          title: "Error creating list",
          text: err,
          time: 4000
        });
      }
      this.createNewListPromptActive = false;
    }
  },
  async created() {
    const activeCountry = this.$store.getters["venues/activeCountry"];
    await this.$store.dispatch("lists/getLatestLists", activeCountry.id);
    await this.$store.dispatch("listRules/getRules", activeCountry.id);
  }
};
</script>

<style lang="scss">
.card-image-custom {
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  background-repeat: no-repeat;
  background-size: cover;
  /*background-image: linear-gradient(
    to right,
    rgba(var(--vs-primary), 0.7),
    rgba(var(--vs-primary), 1)
  );*/
  height: 140px;
}
</style>